import { render } from "./Widget19.vue?vue&type=template&id=abddd95c&scoped=true"
import script from "./Widget19.vue?vue&type=script&lang=js"
export * from "./Widget19.vue?vue&type=script&lang=js"

import "./Widget19.vue?vue&type=style&index=0&id=abddd95c&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abddd95c"]])

export default __exports__